import { calcTotal } from '@utils/order-form'
export default {
    components: {

    },
    filters: {
    },
    data() {
        return {
        }
    },
    computed: {
        /**
         * @description 計算子訂單total價錢
         * @returns 
         */
        childrenOrderTotal() {
            this.updateBasePrice(true)
            return calcTotal({ price: 0, totalEditList: this.childrenSubmitData.params, memberInfo: this.memberInfo })
        },
        /**
         * 
         */
        reservationTotal() {
            const data = this.orderType === 'reservation' ? this.reservationItem : this.goodsItem
            this.$set(data, 'priceId', parseInt(data.priceId) || 0)
            return this.composeTotal(data, this.composeMemberLevelDiscount(data))
        },
    },
    watch: {

    },
    created() {

    },
    methods: {

    }
}